import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, distinctUntilChanged } from 'rxjs';
import Step from 'shepherd.js/src/types/step';
import { environment } from 'src/environments/environment';
import {
  OnboardingModel,
  OnboardingVerifyEmail,
} from '../models/onboarding.interface';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  //General
  steps: boolean[] = [];
  onboardingProgress = new BehaviorSubject<number>(0);
  private _showOnboardingDashboard = new Subject();
  readonly showOnboardingDashboard$ = this._showOnboardingDashboard
    .asObservable()
    .pipe(distinctUntilChanged());

  //Products & Services
  productsTutorial = false;
  newProductTutorial = false;
  newServiceTutorial = false;

  //Sales
  salesTutorial = false;
  newSalesTutorial = false;

  constructor(private http: HttpClient) {}

  setStep(index: number, value: boolean) {
    this.steps[index] = value;

    const progress =
      this.steps.length > 0
        ? this.steps.filter((x) => x === true).length / this.steps.length
        : 0;
    this.onboardingProgress.next(progress);
  }

  setOnboardingDashboard(state: boolean) {
    this._showOnboardingDashboard.next(state);
  }

  getStepOptionsDefault(): Step.StepOptions {
    return {
      scrollTo: false,
      modalOverlayOpeningPadding: 5,
      modalOverlayOpeningRadius: 8,
      cancelIcon: {
        enabled: true,
      },
      arrow: false,
    };
  }

  primaryButtonClasses() {
    return 'yc-btn yc-btn-primary button-default-text';
  }

  secondaryButtonClasses() {
    return 'yc-btn yc-btn-tertary button-default-text';
  }

  getRequiredElementsDefault() {
    return [
      {
        selector: '.search-result-element',
        message:
          'No search results found. Please execute another search, and try to start the tour again.',
        title: 'No results',
      },
      {
        selector: '.username-element',
        message: 'User not logged in, please log in to start this tour.',
        title: 'Please login',
      },
    ];
  }

  getOnboardingData() {
    return this.http.get<OnboardingModel>(`${environment.API_URL}/OnBoarding`);
  }

  verifyEmail() {
    return this.http.get<OnboardingVerifyEmail>(
      `${environment.API_URL}/VerificacionCorreo/Enviar`
    );
  }

  setData(data: OnboardingModel) {
    this.setStep(0, data.CorreoVerificado);
    this.setStep(1, data.ProductoCreado);
    this.setStep(2, data.CorrelativoCreado);
  }
}
